import { render, staticRenderFns } from "./RelatorioContasAReceberView.vue?vue&type=template&id=5c85f86c&scoped=true"
import script from "./RelatorioContasAReceberView.vue?vue&type=script&lang=js"
export * from "./RelatorioContasAReceberView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioContasAReceberView.vue?vue&type=style&index=0&id=5c85f86c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c85f86c",
  null
  
)

export default component.exports